export default {
    FILE_STORAGE: {
        ROOT_PATH: "~/fs/",
        TEMP_PATH: "~/fs/temp/",
        PINYIN_PATH: "~/fs/dictionary/pinyin/",
    },
    LOCAL_FILE_STORAGE: {
        ROOT_PATH: "/fs/",
        TEMP_PATH: "/fs/temp/",
        TALK_CHINESE_ROOT_PATH: "/fs/users/talkchinese/", // TODO from wei: need to remove this one
    },
    TEXT_MARK_TYPE: {
        PLAIN_TEXT: 1,
        HIGHLIGHT: 2,
        INPUT: 4,
        UNDERLINE: 8,
        BOLD: 16,
        POP_INPUT: 32, // a text that you can click it, a bottom sheet with a input will show and you can set the row of input, after input the content will be your input
        ICON: 64,
        SKIP: 128,
        KEYWORD: 256,
        TYPO: 512,
        MISSPELT: 1024,
        NUMBER: 2048,
        ERRORLETTER: 4096,
        WRITE_INPUT: 8192, // handwriting input
    },
    SENTENCE_MARK_TYPE: {
        PLAIN_TEXT: 1,
        ALIGN_CENTER: 2,
        ALIGN_RIGHT: 4,
        LEFT_INDENT: 8, //indent the paragraph at left
        DIALOG: 16,
    },
    FIELD_TYPE: {
        CHARSFIELD: 0,
        IMAGEFIELD: 1,
        AUDIOFIELD: 2,
    },
    TABLE_COLUMN_TYPE: {
        UNKNOWN: 0,
        TEXT: 1,
        IMAGE: 2,
        TRANSLATION: 3,
    },
    FIELD_TYPE_MAP_ARRAY: ["CharsField", "ImageField", "AudioField"],
    VALID_MP3_MIMES: [
        "audio/mpeg",
        "audio/x-mpeg",
        "audio/mp3",
        "audio/x-mp3",
        "audio/mpeg3",
        "audio/x-mpeg3",
        "audio/x-mpeg-3",
        "audio/mpg",
        "audio/x-mpg",
        "audio/x-mpegaudio",
        "video/mpeg",
        "video/x-mpeg",
    ],
    SUPER_ADMIN_ID: "10001",
    CHARS_FIELD_SYLLABLES_SEPARATOR: "%#%",
    USER_GUEST: "Guest",
    SUPPORTED_LANGUAGES: [
        { code: "zh", name: "中文", culture: "zh-CN" },
        { code: "en", name: "English", culture: "en-US" },
        { code: "ja", name: "日語", culture: "ja-JP" },
    ],
    USER_ROLE: {
        USER: 0,
        ADMIN: 1, // SuperAdmin
        GENERAL_ADMIN: 2, // GeneralAdmin
        OPERATOR: 4, // 平台运营人员
        CUSTOMER_SERVICE: 8, // 平台客服人员
        REGION_ADMIN: 16, // 区域管理员
        REGION_OPERATOR: 32, // 区域运营人员
        REGION_CUSTOMER_SERVICE: 64, // 区域客服人员
        STORE_ADMIN: 128, // 门店管理员
        STORE_USER: 256, // 门店员工
    },
    USER_TABLE_TYPES: {
        EMPLOYEE_USER: 0,
        PROVIDER_USER: 1,
        CONSUMER_USER: 2,
        STORE_USER: 3,
        REGION_USER: 4,
        MARKETER: 5,
        AGENT: 6,
        VIRTUAL_STORE_USER: 7,
        STORE: 8,
    },
    BACKGROUND_TASK_TYPE: {
        API_CALL: "API_CALL",
        UNIT_API_CALL: "UNIT_API_CALL",
        UPDATE_UNIT_RESULT: "UPDATE_UNIT_RESULT",
        UNIT_UPLOAD: "UNIT_UPLOAD",
        RESTART_UNIT: "RESTART_UNIT",
        RECOGNIZE_AUDIO: "RECOGNIZE_AUDIO",
        COMPLETE_HOMEWORK: "COMPLETE_HOMEWORK",
        START_HOMEWORK: "START_HOMEWORK",
    },
    BACKGROUND_TASK_QUEUE_TYPE: {
        NORMAL: "NORMAL TASK",
        UPLOAD: "UPLOAD TASK",
    },
    PRIMARY_COLOR: "#19589b",
    SECONDARY_COLOR: "#eea236",
    CODES: {
        SPA_CLIENT_OLD: -100,
        TO_BE_AUTHENTICATED: -1,
        ACCESS_VIOLATION: -2,
        MISSING_EMAIL: -3,
        SSO_VIOLATED: 108,
        NOT_EXIST_CURUSER: -8,
        ACCOUNT_NOT_EXIST: 100,
        INACTIVE_ACCOUNT: 101,
        EXIST_ACCOUNT: 103,
        MUST_IN_WAITLIST_DUE_TO_MIN_PLAYER_BOUND: 119,
        MUST_IN_WAITLIST_DUE_TO_MIN_RESTRICT_TEAM_JOIN: 120,
        USER_HOMEWORK_UNIT_NOT_EXIST: 123,
        USER_HOMEWORK_NOT_EXIST: 124,
        ALREADY_JOINED_TEAM: 125,
        TEAM_JOIN_PENDING: 126,
        INVITED_MEMBER_JOIN: 127,
        ADDED_MEMBER_BY_ADMIN: 128,
        USER_HOMEWORK_NOT_COMPLETED: 130,
        USER_HOMEWORK_ALREADY_COMPLETED: 131,
        NEED_PASS_QUIZ: 138,
        INVALID_NETWORK_EMAIL: 140,
        REQUIRE_PAYMENT: 141,
        REQUIRE_SIGN_WAIVERS: 142,
        REQUIRE_SET_PASSWORD: 143,
        REQUIRE_COMPLETE_REGISTRATION: 144,
        REQUIRE_LINK_FACEBOOK: 145,
        REQUIRE_HTTPS: 146,
        REQUIRE_ACCEPT_TERM: 160,
        NEED_REDIRECT_TO_PAYMENT: 162,
        RECAPTCHA_VALIDATION_FAIL: 157,
        REMOVE_TEAM_CAPTAIN_ERROR: 170,
        REQUIRE_SSO_SET_PASSWORD: 176,
        ALREADY_SCHOOL_MEMBER: 179,
        PENDING_JOIN_SCHOOL_REQUEST: 180,
        HAVE_NO_JOINED_SCHOOL: 183,
        NOT_SESSION_MEMBER: 185,
        NOT_GAME_MEMBER: 186,
        REQUIE_VALID_TEAM: 187,
        TEAM_DOES_NOT_EXIST: 188,
        NEED_TO_CHOOSE_PACKAGE: 189,
        NOT_EVENT_MEMBER: 191,
        CAN_JOIN_AS_NOMAD: 192,
        NEED_CREATE_NEW_ACCOUNT: 202,
        SID_IN_USE: 400,
        SID_PENDING_REQUEST: 401,
        SID_VERIFY_FAILED: 402,
        SID_NOT_MATCH: 404,
        SID_NOT_IN_SHEET: 405,
        FITNESS_DISABLED: 600,
        CLUB_DISABLED: 700,
        CLIENT_TIMEOUT: -999,
        BACKGROUND_TASK_NOT_READY: -1000,
    },
    MOBILE_UID_PREFIX: "mobile",
    PASSWORD_REGEX: /^(?=.*[A-Za-z])(?=.*\d)[\d\D]{8,}$/, //数字和字母组合，长度至少8位
    HOMEWORK_RESULT_GRADE: {
        PERFECT: "It's Perfect",
        EXCELLENT: "Excellent !",
        GOOD: "Very Good",
        PITY: "What a Pity",
    },
    ENTITY_TYPE: {
        PORTAL: "portal",
        MEMBER: "member",
        ACCOUNT: "account",
        NETWORK: "network",
        SPORT: "sport",
        LEAGUE: "league",
        DIVISION: "division",
        REGULARGAME: "regulargame",
        PLAYOFFGAME: "playoffgame",
        TEAM: "team",
        CLUB: "club",
        FITNESS: "fitness",
        INTRAMURAL: "intramural",
        PLAYOFF: "playoff",
        CONVERSATION: "conversation",
        FITNESSSESSION: "fitnesssession",
    },
    PAYMENT: {
        CURRENCY_TYPE: {
            USD: "USD",
            CNY: "CNY",
        },
        GATEWAY: {
            //BRAINTREE: 0,
            WECHAT: 0,
            STRIPNET: 1,
            ALIPAY: 2,
            MOCK: 100,
        },
        ORDER_STATUS: {
            NEW: 0,
            COMPLETED: 1,
            TO_BE_PROCESSED: 2,
            PROCESSING_FAILURE: 3,
            NOTIFICATION_RECEIVED: 4,
            VERIFICATION_FAILED: 5,
            ORDER_DENIED: 6,
            TO_BE_DENIED: 7,
            PENDING: 8,
        },
    },
    SPEECH_CONSTANT: {
        DEFAULT_RECOGNIZE_TIME_OUT: 180,
        MAX_RECOGNIZE_TIME_OUT: 180,
        DEFAULT_WORD_RECOGNIZE_TIME_OUT: 20,
        MAX_WORD_RECOGNIZE_TIME_OUT: 40,
    },
    SPEECH_LANG: {
        en: "en-US",
        zh: "zh-CN",
    },
    COURSE_CATEGORY: {
        POEM: 0,
        NOVEL: 1,
        CHILDREN_STORY: 2,
        SPOKEN_LANGUAGE: 3,
        IDIOMSTORY: 4,
        CLASSIC_ARTICLE: 5,
    },
    AnswerTypeEnum: {
        AnswerType_DirectInput: 1,
        AnswerType_UploadFile: 2,
        AnswerType_DirectInputOrUploadFile: 3, // 1|2
        AnswerType_Audio: 4,
        //AnswerType_DirectInputOrAudio: 5, // 1|4
        AnswerType_UploadImage: 8,
        //AnswerType_DirectInputOrUploadImage: 9, // 1|8
    },
    AnswerTypeCookieKey: {
        Audio: "AnswerType_Audio",
        UploadImage: "AnswerType_UploadImage",
    },
    UnitViewModeEnum: {
        Normal: 0,
        SimpleBatch: 1,
        Homework: 2,
    },
    DefaultPageSize: 50,
    SERVICE_PRICE_TYPE: {
        CONSTANT: 1,
        DAY_PERIOD: 2,
        PERCENTAGE_DAY_PERIOD: 3,
    },
    PHONE_EMAIL_DOMAIN: "phone.yofrive.com",
    ROUTE_ACCESS: {
        PUBLIC: "public", // Not login required
        PRIVATE: "private", // Login required
        ADMIN: "admin", // Admin only
        REGION: "region", // Region admin or Admin
        STORE: "store", // Store admin or Admin
        ONCALL: "oncall", // Oncall or Admin
    },
    WITHDRAWAL_TYPES: {
        INCOME: 0,
        DEPOSIT: 1,
    },
    TRANSACTION_STATUS: {
        PENDING: 0,
        PROCESSING: 1,
        COMPLETED: 2,
        FAILED: 3,
    },
    USER_STATUS: {
        ACTIVATED: 0,
        REGISTERED: 1,
        REVIEWING: 2,
        SUSPENDED: 3,
        TOBECERTIFIED: 4,
    },
    RESERVATION_STATUS: {
        CONSUMER_CREATED: 0,
        PROVIDER_RECEIVED: 1,
        PROVIDER_ON_THE_WAY: 2,
        PROVIDER_ARRIVED: 7,
        SERVICE_STARTED: 3,
        WAITING_FOR_BONUS_ORDER: 4,
        WAITING_FOR_CONSUMER_PAYMENT: 5,
        COMPLETED: 6,
        CANCELLED: 10,
        WAITING_FOR_FORFEIT_FEE_ORDER: 11,
    },
    COUPON_STATUS: {
        ONGOING: 0,
        ENDED: 1,
    },
    COUPON_DISCOUNT_TYPE: {
        COUPON: 0,
        PROMOTION: 1,
    },
    PROMOTION_STATUS: {
        ONGOING: 0,
        ENDED: 1,
    },
    COUPON_OWNER_TYPE: {
        PROVIDER: 0,
        REGION: 1,
        PLATFORM: 2,
        STORE: 3,
    },
    PROMOTION_OWNER_TYPE: {
        PROVIDER: 0,
        REGION: 1,
        PLATFORM: 2,
    },
    SERVICE_OFFER_TYPE: {
        IN_STORE: 1,
        HOME_VISIT: 2,
        ALL: 3,
    },
    RESERVATION_ALARM_STATUS: {
        NONE: 0,
        ALARMED: 1,
        RESOLVED: 2,
    },

    TRAFFIC_WAY: {
        NONE: 0,
        TAXI: 1,
        BUS: 2,
        SUBWAY: 3,
        OTHER: 4,
    },
    DEBT_TYPE: {
        NONE: 0,
        PAY_FOR_PROVIDER_FORFEIT_FEE: 1, //技师支付违约金
        PAY_FOR_CONSUMER_FORFEIT_FEE: 2, //客户支付违约金
        PAY_FOR_PROVIDER_SETTLEMENT_FEE: 3, //技师结算平台提成
        PAY_FOR_CONSUMER_SETTLEMENT_FEE: 4, //客户结算服务费用
        PAY_FOR_PROVIDER_RESERVATION_REWARD: 5, //预约技师补偿
        PAY_FOR_PROVIDER_RESERVATION_PENALTY: 6, //预约技师罚款
        PAY_FOR_CONSUMER_RESERVATION_REWARD: 7, //预约客户补偿
        PAY_FOR_CONSUMER_RESERVATION_PENALTY: 8, //预约客户罚款
    },
    DEFAULT_ISO_CODE: "86",
    DEFAULT_COUNTRY_CODE: "CHN",
    // 编码规则：
    // 1. 正负号表示金额方向：正=收入/增加，负=支出/减少
    // 2. 类别前缀：
    //    1xx = 预约变动
    //    2xx = 余额变动（包括收入、转入、转出、充值、提现等）
    //    9xx = 卡券变动（创建、退回、结余退回）
    // 3. 同类交易按动作顺序编号，便于记忆和理解
    TRANSACTION_TYPE: {
        CONSUMER_INCOME: {
            REFUND_CONSUMER_PAYMENT: 114, // 预约退款（+）
            NET_EXTRA_INCOME: 201, // 额外收入（+）
            TRANSFER_INCOME_TO_SPENDING: -202, // 余额转出（-）
            WITHDRAWAL_INCOME: -205, // 余额提现（-）
        },
        PROVIDER_INCOME: {
            SERVICE_COMMISSION: 102, // 服务佣金（+）
            TRAFFIC_FEE: 103, // 交通费用（+）
            NET_EXTRA_INCOME: 201, // 额外收入（+）
            PLATFORM_INCENTIVE: 202, // 平台激励收入（月结）
            PLATFORM_INCENTIVE_IMMEDIATE: 203, // 平台激励收入（即时结算）
            TRANSFER_INCOME_TO_SPENDING: -202, // 余额转出（-）
            WITHDRAWAL_INCOME: -205, // 余额提现（-）
            REFUND_COUPON: 902, // 卡券退回（+）
            REFUND_COUPON_REMAINING: 903, // 卡券结余退回（+）
            REFUND_COUPON_EXPIRED: 904, // 卡券过期退回（+）
        },
        MARKETER_INCOME: {
            NET_EXTRA_INCOME: 201, // 额外收入（+）
            TRANSFER_INCOME_TO_SPENDING: -202, // 余额转出（-）
            WITHDRAWAL_INCOME: -205, // 余额提现（-）
        },
        CONSUMER_SPENDING: {
            RESERVATION: -101, // 预约支付（-）
            FORFEIT_FEE: -103, // 支付违约（-）
            RESERVATION_PENALTY: -111, // 预约罚款（-）
            RESERVATION_REWARD: 111, // 预约奖励（+）
            GET_SPENDING_FROM_INCOME: 203, // 余额转入（+）
            RECHARGE_SPENDING_BALANCE: 204, // 余额充值（+）
        },
        PROVIDER_SPENDING: {
            SETTLEMENT: -101, // 结算预约支付（-）
            RESERVATION_PENALTY: -111, // 预约罚款（-）
            RESERVATION_REWARD: 111, // 预约奖励（+）
            GET_SPENDING_FROM_INCOME: 203, // 余额转入（+）
            RECHARGE_SPENDING_BALANCE: 204, // 余额充值（+）
            CREATE_COUPON: -901, // 创建卡券（-）
        },
        MARKETER_SPENDING: {
            GET_SPENDING_FROM_INCOME: 203, // 余额转入（+）
        },
        REGION: {
            PAY_RESERVATION_REWARD: -111, // 预约奖励（-）
            TAKE_RESERVATION_PENALTY: 111, // 预约罚款（+）
            ACCEPT_RESERVATION_REWARD: 112, // 接受预约奖励（+）
            ACCEPT_RESERVATION_PENALTY: -112, // 接受预约罚款（-）
            CREATE_COUPON: -901, // 创建卡券（-）
            USE_NEW_USER_COUPON: -905, //新用户优惠券使用扣款(-)
            MONTHLY_INCOME: 201, // 月度收入（+）
            PLATFORM_INCENTIVE: -202, // 平台激励支出（月结）
            PLATFORM_INCENTIVE_IMMEDIATE: -203, // 平台激励支出（即时结算）
            WITHDRAWAL_INCOME: -205, // 余额提现（-）
            REFUND_COUPON: 902, // 卡券退回（+）
            REFUND_COUPON_REMAINING: 903, // 卡券结余退回（+）
            REFUND_COUPON_EXPIRED: 904, // 卡券过期退回（+）
        },
        STORE: {
            SETTLEMENT: -101,        // 门店结算扣款
            SERVICE_COMMISSION: 102,  // 门店服务提成入账（系统代收或线下结算为负时平台补贴）
            PLATFORM_INCENTIVE_IMMEDIATE: 108, // 门店平台激励即时结算入账
            RECHARGE: 204,           // 门店充值
            WITHDRAWAL: -205,        // 门店提现
            COUPON_USED_FOR_RESERVATION: -901, // 门店券成本扣款（门店预约中若使用 Provider 券，成本由门店承担）
        },
    },
    USER_SOURCE_TYPE: {
        UNKNOWN: 0, // 未知来源
        MOBILE: 1, // 手机推荐
        WECHAT: 2, // 微信推荐
        EMAIL: 3, // 邮件推荐
        SCAN_QRCODE: 4, // 扫码推荐
        LINK: 5, // 链接推荐
        SHARE: 6, // 分享推荐
        WECHAT_MOMENTS: 7, // 微信朋友圈推荐
        POSTER: 8, // 海报推荐
        PROMOTION: 9, // Promotion
        SELF_REGISTERED: 999, // 自己注册
        REFERRAL_CODE: 1000, // ReferralCode
    },
    ANNOUNCEMENT_CONTENT_TYPE: {
        IMAGE: 0,
        TEXT: 1,
        VIDEO: 2,
    },
    RESERVATION_REWARD_PENALTY_TYPE: {
        REWARD: 0,
        PENALTY: 1,
    },
    RESERVATION_ABNORMAL_TYPE: {
        NONE: 0,
        CONFIRMATION_TIMEOUT: 1,
        SET_OUT_TIMEOUT: 2,
        ARRIVAL_TIMEOUT: 3,
        SERVICE_START_TIMEOUT: 4,
        SERVICE_OVERTIME: 5,
        PAYMENT_TIMEOUT: 6,
        PROVIDER_LEAVE_TIMEOUT: 7,
        COMPLETION_TIMEOUT: 8,
    },
    TODO_TASK_TYPE: {
        REGION_JION_REQUEST: 0, // 区域加入请求审核
        CONSUMER_SERVICE: 1, // 客服请求
        CONSUMER_REVIEW: 2, // 客户评价审核
        PROVIDER_REVIEW: 3, // 技师评价审核
        CONSUMER_REPORT: 4, // 客户投诉处理
        CONSUMER_WITHDRAWAL: 5, // 客户提现
        PROVIDER_WITHDRAWAL: 6, // 技师提现
        MARKETER_WITHDRAWAL: 7, // 云店提现
        REGION_USER_WITHDRAWAL: 8, // 区域提现
        FEEDBACK: 9, // 建议反馈
        CANCEL_RESERVATION_WITHOUT_LIABILITY: 10, //无责取消预约申请
        RESERVATION_REWARD_PENALTY: 11, //预约补偿/罚款
        ABNORMAL_RESERVATION: 12, //异常预约处理请求
        PROVIDER_REGISTER: 13, //技师入驻
        PROVIDER_LEVEL_EVALUATION: 14, //技师等级评估
        USER_AUTHENTICATION: 15, //用户身份验证
        FREE_RESERVATION: 16, // 免费预约
        CONSUMER_REGISTER: 20, // 客户注册审核
        MARKETER_REGISTER: 22, // 营主注册审核
        STORE_WITHDRAWAL: 27, // 门店提现
    },
    WITHDRAW_GATEWAY: {
        WECHAT: 0,
        ALIPAY: 1,
        BANK_CARD: 2,
        MOCK: 100,
    },
    RESERVATION_MONITOR_STATUS: {
        NORMAL: 0,
        ALARM: 1,
        ABNORMAL: 2,
    },
    DEFAULT_SERVICE_ITEM_DURATION: 5,
    RECIPIENT_TYPE: {
        CONSUMER: 0,
        PROVIDER: 1,
        REGION: 2,
    },
    FREE_RESERVATION_STATUS: {
        AVAILABLE: 0,  // 可预约
        BOOKED: 1,     // 已预约
        FINISHED: 2,    // 已完成
    },
    COORDINATE_SYSTEM: {
        WGS84: 0,
        GCJ02: 1,
        BD09: 2,
    },
    STORE_STATUS: {
        DISABLE: 0,
        ENABLE: 1,
    },
    STORE_ROOM_LOGICAL_STATUS: {
        AVAILABLE: 0,
        OCCUPIED: 1,
        CLEANING: 2,
    },
    STORE_ROOM_PHYSICAL_STATUS: {
        NORMAL: 0,
        MAINTENANCE: 1,
    },

    STORE_PROVIDER_STATUS: {
        ON_DUTY: 0,
        OFF_DUTY: 1,
        WAITING: 2,
        IN_SERVICE: 3,
    },
    STORE_RESERVATION_STATUS: {
        WAITING: 0,    // 待服务
        IN_SERVICE: 1,  // 服务中
        COMPLETED: 2,  // 已完成
        CANCELLED: 3,  // 已取消
        WAITING_FOR_BONUS_ORDER: 4,  // 待结算
    },
};
